import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FitQuizLayoutContainer } from "@platform/features/invitation";
import { useInvitation, usePlatformStore } from "@platform/store";
import { useClaimInvitation } from "@core/features/invitation";
import type { QuizFormData } from "@core/features/quiz";

export function InvitationFitQuizPage() {
  const navigate = useNavigate();
  const user = usePlatformStore((s) => s.user);
  const { invitation, claimedVia } = useInvitation();
  const { mutate: claimInvitation } = useClaimInvitation();

  // Get quiz ID from invitation display_options
  const quizId = invitation?.display_options?.quiz_id;

  // If no quiz configured, redirect to signup
  useEffect(() => {
    if (invitation && !quizId) {
      navigate(`/invitation/${invitation.shortcode}/signup`, { replace: true });
    }
  }, [invitation, quizId, navigate]);

  const handleQuizComplete = (formData: QuizFormData) => {
    if (!invitation?.shortcode) return;

    // Store quiz answers in sessionStorage for later submission after signup
    sessionStorage.setItem(
      `fitQuizAnswers_${invitation.shortcode}`,
      JSON.stringify(formData)
    );

    if (user) {
      // Logged in user: claim invitation via API
      claimInvitation({
        shortcode: invitation.shortcode,
        claimedVia: claimedVia ?? "direct_link",
      });
    } else {
      // New user: go to signup
      navigate(`/invitation/${invitation.shortcode}/signup`);
    }
  };

  // Don't render if no quiz (redirect will happen via useEffect)
  if (!quizId) {
    return null;
  }

  return (
    <FitQuizLayoutContainer quizId={quizId} onComplete={handleQuizComplete} />
  );
}

export default InvitationFitQuizPage;
